<template>
  <v-navigation-drawer app left clipped :value="drawer">
    <v-list dense nav>
      <div v-for="(item, i) in items" :key="item.title + i">
        <!-- Если у элемента есть подменю -->
        <v-list-group v-if="item.subItems && item.subItems.length > 0">
          <template v-slot:activator>
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </template>

          <v-list-item
              class="sub-item"
              v-for="(subItem, j) in item.subItems"
              :key="subItem.title + j"
              :to="subItem.to"
              link
          >
            <v-list-item-icon>
              <v-icon>{{ subItem.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-group>

        <!-- Если подменю нет -->
        <v-list-item v-else :key="item.title + i" link :to="item.to">
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "AppSidebar",
  props: {
    drawer: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isRoleAdmin () {
      return this.$store.getters["auth/isRoleAdmin"]
    },
    isRolePartner () {
      return this.$store.getters["auth/isRolePartner"]
    },
  },
  mounted() {
    if (this.isRoleAdmin) {
      this.items = [
        {
          title: 'Главная',
          icon: 'mdi-home',
          to: '/partner/dashboard'
        },
        {
          title: 'Пользователи',
          icon: 'mdi-account',
          to: '/admin/users',
        },
        {
          title: 'Партнеры',
          icon: 'mdi-account-multiple',
          to: '/admin/partners',
        },
        {
          title: 'Шины',
          icon: 'mdi-tire',
          subItems: [
            { title: 'Каталог шин', icon: 'mdi-format-list-bulleted', to: '/admin/tire/catalog' },
            { title: 'Бренды шин', icon: 'mdi-tag-multiple',to: '/admin/tire/brands' },
          ],
        },
        {
          title: 'Запчасти',
          icon: 'mdi-car-wrench',
          subItems: [
            { title: 'Каталог запчастей', icon: 'mdi-format-list-bulleted', to: '/admin/spare/catalog' },
            { title: 'Бренды запчастей', icon: 'mdi-tag-multiple',to: '/admin/spare/brands' },
          ],
        },
        {
          title: 'Справочник автомобилей',
          icon: 'mdi-car-multiple',
          subItems: [
            { title: 'Марки авто', icon: 'mdi-car', to: '/admin/car/brands' },
            { title: 'Модели авто', icon: 'mdi-car-side',to: '/admin/car/models' },
          ],
        },
        {
          title: 'Сервисы',
          icon: 'mdi-tools',
          subItems: [
            { title: 'Категории', icon: 'mdi-shape-outline', to: '/admin/categories' },
          ],
        },
        // {
        //   title: 'Полезное',
        //   icon: 'mdi-book-open-variant',
        //   to: '',
        // },
      ]
    }
    if (this.isRolePartner) {
      this.items = [
        {
          title: 'Главная',
          icon: 'mdi-home',
          to: '/partner/dashboard'
        },
        {
          title: 'Мои товары',
          icon: 'mdi-package-variant',
          subItems: [
            { title: 'Шины', icon: 'mdi-tire', to: '/partner/tire' },
            { title: 'Запчасти', icon: 'mdi-car-wrench',to: '/partner/spare' },
            { title: 'Виды работ', icon: 'mdi-tools',to: '/partner/jobs' },
            { title: 'Пользователи', icon: 'mdi-account-multiple',to: '/partner/users' }
          ],
        },
        {
          title: 'Каталоги',
          icon: 'mdi-folder-open',
          subItems: [
            { title: 'Каталог шин', icon: 'mdi-tire', to: '/partner/tire-catalog' },
            { title: 'Каталог запчастей', icon: 'mdi-car-wrench',to: '/partner/spare-catalog' },
          ],
        },
        {
          title: 'Запись',
          icon: 'mdi-clock-outline',
          subItems: [
            { title: 'Записи', icon: 'mdi-format-list-bulleted', to: '/9' },
            { title: 'Расписание', icon: 'mdi-calendar-clock',to: '/8' },
          ],
        },
        {
          title: 'Поиск по каталогам',
          icon: 'mdi-magnify',
          subItems: [
            { title: 'Поиск по VIN', icon: 'mdi-car-search', to: '/7' },
            { title: 'Поиск по артиклу', icon: 'mdi-barcode-scan',to: '/6' },
          ],
        },
        {
          title: 'Заказы',
          icon: 'mdi-cart',
          subItems: [
            { title: 'Список заказов', icon: 'mdi-clipboard-list-outline', to: '/partner/orders' },
            { title: 'Корп. заказы', icon: 'mdi-domain',to: '/partner/order-requests' },
          ],
        },
        {
          title: 'Обратная связь',
          icon: 'mdi-message-text-outline',
          subItems: [
            { title: 'Обращения', icon: 'mdi-message-question-outline', to: '/1' },
            { title: 'Мои чаты', icon: 'mdi-chat',to: '/2' },
          ],
        },
        {
          title: 'Заказ наряд',
          icon: 'mdi-file-document-outline',
          to: '/partner/purchase-order',
        },
      ]
    }
  },
  data: () => ({
    items: [
      {
        title: 'Главная',
        icon: 'mdi-home',
        to: '/partner/dashboard'
      },
      {
        title: 'Мои товары',
        icon: 'mdi-package-variant',
        subItems: [
          { title: 'Шины', icon: 'mdi-tire', to: '/partner/tire' },
          { title: 'Запчасти', icon: 'mdi-car-wrench',to: '/partner/spare' },
          { title: 'Виды работ', icon: 'mdi-tools',to: '/partner/jobs' },
          { title: 'Пользователи', icon: 'mdi-account-multiple',to: '/partner/users' }
        ],
      },
      {
        title: 'Каталоги',
        icon: 'mdi-folder-open',
        subItems: [
          { title: 'Каталог шин', icon: 'mdi-tire', to: '/partner/tire-catalog' },
          { title: 'Каталог запчастей', icon: 'mdi-car-wrench',to: '/partner/spare-catalog' },
        ],
      },
      {
        title: 'Запись',
        icon: 'mdi-clock-outline',
        subItems: [
          { title: 'Записи', icon: 'mdi-format-list-bulleted', to: '/9' },
          { title: 'Расписание', icon: 'mdi-calendar-clock',to: '/8' },
        ],
      },
      {
        title: 'Поиск по каталогам',
        icon: 'mdi-magnify',
        subItems: [
          { title: 'Поиск по VIN', icon: 'mdi-car-search', to: '/7' },
          { title: 'Поиск по артиклу', icon: 'mdi-barcode-scan',to: '/6' },
        ],
      },
      {
        title: 'Заказы',
        icon: 'mdi-cart',
        subItems: [
          { title: 'Список заказов', icon: 'mdi-clipboard-list-outline', to: '/partner/orders' },
          { title: 'Корп. заказы', icon: 'mdi-domain',to: '/partner/order-requests' },
        ],
      },
      {
        title: 'Обратная связь',
        icon: 'mdi-message-text-outline',
        subItems: [
          { title: 'Обращения', icon: 'mdi-message-question-outline', to: '/1' },
          { title: 'Мои чаты', icon: 'mdi-chat',to: '/2' },
        ],
      },
      {
        title: 'Заказ наряд',
        icon: 'mdi-file-document-outline',
        to: '/partner/purchase-order',
      },
    ],
  }),
}
</script>

<style scoped>
.sub-item {
  padding-left: 32px !important;
  font-size: 14px;
  color: #1976D2;
  border-left: 3px solid transparent;
  transition: background-color 0.2s ease;
}

.sub-item:hover {
  background-color: #e3f2fd;
  border-left: 3px solid #2196F3;
}
</style>
